// extracted by mini-css-extract-plugin
module.exports = {"taggedItem":"Home_taggedItem__2Ps9s","temp":"Home_temp__Ct251","title":"Home_title__2H4TE","border":"Home_border__1vwwB"};